import { render } from "./NotificationButton.vue?vue&type=template&id=9b493352&scoped=true"
import script from "./NotificationButton.vue?vue&type=script&lang=js"
export * from "./NotificationButton.vue?vue&type=script&lang=js"

import "./NotificationButton.vue?vue&type=style&index=0&id=9b493352&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b493352"]])

export default __exports__